const cs = { // 捷克语Czech
    message: {
        noNet: 'Chyba sítě',
        goCopilot: 'Analyzujte spánek a návrhy na noc',
        goCopilotWeek: 'Analyzujte spánek této týdne',
        goCopilotMonth: 'Analyzovat spánek tohoto měsíce',
        updateAppTips: 'Aktuální verze nelze zobrazit. Prosím, aktualizujte na nejnovější verzi!',
        vip: {
            openVip: "Odemknout členství",
            sleepVip: "Spánkové členství",

            notOpened: "Zatím žádné předplatné",
            expired: "Platnost vypršela",
            validUntil: "Platnost končí: ",
            unlockAll: "Odemknout veškerou hudbu pro podporu spánku",
            trendAnalysis: "Analýza vývoje spánku",
            reportAnalysis: "Personalizovaná měsíční analýza zpráv",
            deepAnalysis: "Hloubková analýza spánku",
            monthlyVip: "Měsíčne",
            quarterlyVip: "Čtvrtletně",
            annualVip: "Roční",
            priceEvery: "{yuan}{price} Měsíčně",
            yuanEveryMonth: "",
            yuanEveryQuarter: "",
            yuanEveryYear: "",
            open: "Odemknout",
            renew: "Obnovit nyní",
            renewal: "Prolongace",
            vipMonthExtention: "",
            vipQuartyExtention: "",
            vipYearExtention: "",
            discountLimited: "Speciální akce {discount} sleva",
            discountDuration: "Limitovaná časová nabídka do {date}",
            vipUseDescription1: 'Odemknout veškerou hudbu pro podporu spánku',
            vipUseDescription2: 'Trendy doby spánku a vstávání',
            vipUseDescription3: 'Trendy srdeční frekvence a kyslíku v krvi',
        },
        sleep: {
            regularSleep: "Běžný spánek",
            nap: "Zdřímnutí",
            hour: "h",
            minute: "min",
            sleepQuality: "Kvalita spánku",
            sober: "Probuzení",
            fastEye: "REM",
            lightSleep: "Lehký spánek",
            darkSleep: "Hluboký spánek",
            sleepStage: "Stádium spánku",
            suggestRange: "Doporučení",
            avgSleepHeartRate: "Průmerná srdeční frkvence při spánku",
            timesEveryMin: "bpm",
            unitsleepbreath: "brpm",
            once: "bpm",
            sleepOxygen: "Kyslík v krvi ve spánku",
            sleepBreath: "Dechová frekvence ve spánku",
            highest: "Max",
            lowest: "Min",
            maximum: "Max",
            minimum: "Min",
            normal: "Normální",
            average: "Průměr",
            openMonitoring:  "Počet případů monitorování spánku",
            longerMonitor: "Větší počet monitorovacích dnů umožní získat přesnější údaje.",
            avgStatistics: "Průměrná data",
            sleepDuration: "Doba spánku",
            bedTime: "Čas ke spaní",
            getUpTime: "Čas probuzení",
            maxSleep: "Nejdelší doba spánku",
            minSleep: "Nejkratší doba spánku",
            earliestBedTime: "Nejdřívější doba spánku",
            latestBedTime: "Nejpozdější doba spánku",
            earliestGetUpTime: "Nejdřívější čas probuzení",
            latestGetUpTime: "Poslední čas probuzení",
            excellent: "Vynikající",
            good: "Dobrý",
            improvement: "Potřebuje zlepšit",
            importance: "Vyžaduje pozornost",
            sleepEnough: "Dostačující: {min}-{max}h",
            sleepToLong: "Příliš dlouho: delší než {hour} h",
            sleepDebt: "Nedostačující: kratší než {hour} h",
            sleepPeriodVary1: "Spánkové cykly se budou lišit podle věku. Soušasný věk, který jste zadali je {age}",
            sleepPeriodVary2: "Spánkové cykly se budou lišit podle věku, soušasný věk, který jste zadali je {month} měsíců",
            toSet: "Nastavení",
            openVipToSee: "Přejete-li si pokračovat, povyšte své členství",
            short_mon: "Po",
            short_tue: "Út",
            short_wed: "St",
            short_thu: "Čt",
            short_fri: "Pá",
            short_sat: "So",
            short_sun: "Ne",
            mon: "Po",
            tue: "Út",
            wed: "St",
            thu: "Čt",
            fri: "Pá",
            sat: "So",
            sun: "Ne",
            monday: "Po",
            tuesday: "Út",
            wednesday: "St",
            thursday: "Čt",
            friday: "Pá",
            saturday: "So",
            sunday: "Ne",
            day: "",
            heartRate: "Srdeční frekvence",
            bloodOxygen: "Kyslík v krvi",
            breathRate: "Dechová frekvence",
            noData: "Žádné pravidelné záznamy spánku",
            noNapData: "Žádné záznamy o zdřímnutí",


            sleepLateTipCommonStart: "Včera večer jste šli spát později, než bylo plánováno.",
            sleepTipCommonEnd: "Dodržování pravidelného spánkového režimu je dobré pro vaše zdraví.",
            sleepLate3tip: "Tento týden jste vstali později než obvykle. Tento týden se to stalo {day} dní. Dbejte prosím na svůj spánek bez ohledu na svou rutinu.",
            sleepLate2TipStart: "Včera večer jste šli spát později, než bylo plánováno.",
            sleepLate2Tip: "Tento týden jste šli spát později než obvykle. Tohle je váš druhý den v řadě. Dbejte prosím na to, abyste měli dostatek spánku.",
            getUpEarlyTip: "Dnes jste vstali dříve, než bylo naplánováno.",
            getUpLateTip: "Dnes jste vstali později, než bylo naplánováno.",
            sleepEarlyTip: "Včera jsi šel spát dřív, než bylo plánováno.",



            demoData: "Demo data",


            sleepCompare: "Srovnání údajů o spánku",
            seeMore: "Více",
            sleepQualityData: "Kvalita vašeho spánku je {value}",
            sleepQualityCompare1: "což překonává ",
            sleepQualityCompare2: "Podíl vysoké hodnoty", // todo
            sleepQualityCompare3: "procent uživatelů",
            sleepQualityBestTip: "Udržování dobrého spánku může zajistit zdravý spánek～",
            sleepQualityGoodTip: "Je třeba zlepšit kvalitu spánku!",
            sleepQualityBadTip: "Věnujte prosím pozornost a přejeme vám klidný spánek",
            sleepTimeText: "Doba spánku",
            avgCnSleepTimeText: "中国平均睡眠时长",
            avgGlobalSleepTime: "Globální průměrná délka spánku",
            sleepTimeTip: "Každý by měl spát dostatečně dlouho, aby se účinně zbavil únavy a prospěl svému zdraví, ale nespěte příliš dlouho.",
            bedTimeText: "Čas ke spaní",
            avgCnBedTimeText: "中国平均就寝时间",
            avgGlobalBedTime: "Globální průměrná doba spánku",
            bedTimeTip: "Čas na spaní se zdá být jednoduchý, ale ve skutečnosti je to klíčový ukazatel; dodržování správného režimu před spaním může chránit váš mozek, usnadnit usínání a zlepšit kvalitu spánku. kvalitu vašeho spánku.",
            getUpTimeText: "Čas probuzení",
            avgCnGetUpTimeText: "中国平均起床时间",
            avgGlobalGetUpTime: "Globální průměrná doba probuzení",
            getUpTimeTip: "Nezanedbatelným ukazatelem je také čas vstávání; pravidelný čas vstávání vám může pomoci k dobrému psychickému stavu po celý den",

            sleepStageTitle: "Analýza spánkových fází",
            avgAwakeSleep: "Prům. doba bdění",
            avgFastEyeMove: "Prům. REM",
            avgShallowSleep: "Prům. lehký spánek",
            avgDeepSleep: "Prům. hluboký spánek",

            skinTemperature: "Kožní teplota",
            temperatureLow: "Nízký podíl",
            temperatureHigh: "Podíl vysoké hodnoty",
            reasonableRange: "Rozumný rozsah",

            compare: {
                dataInsights: 'Datové poznání',
                today: 'Dnes',
                yesterday: 'Včera',
                currentWeek: 'Tento týden',
                preWeek: 'Minulý týden',
                currentMonth: 'Tento měsíc',
                preMonth: 'Minulý měsíc',
                daySleepTimeHigher: 'Dnešní délka spánku je delší než včerejší.',
                daySleepTimerLower: 'Dnešní délka spánku je kratší než včerejší.',
                daySleepTimerRegular: 'Délka spánku posledních dvou dnů je poměrně stabilní.',

                dayBedTimeEarly: 'Doba spánku dnes je dříve než včera.',
                dayBedTimeLater: 'Doba spánku dnes je později než včera.',
                dayBedTimeRegular: 'Poslední dva dny byl spánek poměrně pravidelný.',

                dayGetupTimeEarly: 'Dnes byl čas probuzení dřív než včera.',
                dayGetupTimeLater: 'Dnes byl čas probuzení později než včera.',
                dayGetupTimeRegular: 'Poslední dva dny byly časy probuzení docela pravidelné.',
                DayEmptyTip: 'Včera nedošlo k žádnému záznamu spánku. Pokračování nošení zařízení v průběhu spánku vám může pomoci porozumět údajům o spánku.',


                weekSleepTimeHigher: 'Průměrná délka spánku v tomto týdnu je delší než minulý týden.',
                weekSleepTimerLower: 'Průměrná délka spánku v tomto týdnu je kratší než minulý týden.',
                weekSleepTimerRegular: 'Průměrná délka spánku v posledních dvou týdnech je poměrně pravidelná.',

                weekBedTimeEarly: 'Průměrný čas usínání v tomto týdnu je dříve než minulý týden.',
                weekBedTimeLater: 'Průměrný čas usínání v tomto týdnu je později než minulý týden.',
                weekBedTimeRegular: 'Průměrný čas usínání v posledních dvou týdnech je poměrně pravidelný.',

                weekGetupTimeEarly: 'Průměrný čas vstávání v tomto týdnu je dříve než minulý týden.',
                weekGetupTimeLater: 'Průměrný čas vstávání v tomto týdnu je později než minulý týden.',
                weekGetupTimeRegular: 'Průměrný čas vstávání v posledních dvou týdnech byl poměrně pravidelný.',
                weekEmptyTip: 'V posledním týdnu nebyly žádné data o spánku, ale nošení zařízení při spánku vám může pomoci porozumět vašim datům o spánku.',


                monthSleepTimeHigher: 'Průměrná délka spánku tohoto měsíce je delší než minulý měsíc.',
                monthSleepTimerLower: 'Průměrná délka spánku tohoto měsíce je kratší než minulý měsíc.',
                monthSleepTimerRegular: 'Průměrná délka spánku za poslední dva měsíce je poměrně pravidelná.',

                monthBedTimeEarly: 'Průměrná doba usínání tohoto měsíce je dříve než minulý měsíc.',
                monthBedTimeLater: 'Průměrná doba usínání tohoto měsíce je později než minulý měsíc.',
                monthBedTimeRegular: 'Průměrná doba usínání v posledních dvou měsících je poměrně pravidelná.',

                monthGetupTimeEarly: 'Průměrná doba probuzení tohoto měsíce je dřív než minulý měsíc.',
                monthGetupTimeLater: 'Průměrná doba probuzení tohoto měsíce je později než minulý měsíc.',
                monthGetupTimeRegular: 'Průměrná doba probuzení za poslední dva měsíce je poměrně pravidelná.',
                monthEmptyTip: 'V minulém měsíci nebyly zaznamenány žádné údaje o spánku. Nošení zařízení na sledování spánku vám může pomoci porozumět vašim informacím o datech spánku.',

                delete: 'Smazat',
                deleteTitle: 'Smazat záznamy denních zpráv?',
                deleteContent: 'Po smazání denních záznamů budou smazány i odpovídající týdenní a měsíční záznamy. Chcete trvale smazat aktuální denní záznamy?',
                confirm: 'Potvrdit',
                cancel: 'Zrušit'

            }

        },
        advert: { // todo
            tip: 'Early birds DISCOUNT',
            ActivityStartTime: 'Čas zahájení',
            ActivityEndTime: 'Čas ukončení',
            ActivityEnded: '已结束～',
            buy: 'Purchase now',
            explainTitle: 'Activity description:',
            explainDesc1: '1. The special offer for early birds is from December 16th, 2022 to December 31st, 2022.',
            explainDesc2: '2. During the activity, you can purchase the member rights with a discount of 65%.',
            explainDesc3: '3. After you recharge successfully, you can check the validity period of your membership in “Home-Sleep Card-Start to Sleep-vip”',
            explainDescLast: '4. mobvoi has the right of the final interpretation of this activity.',
            viewVipFunctions: 'Check functions of membership.',
            VipFunctionsExplain: "Functions of membership"
        },
        snore: {
            "snoringDetectionReport": "Zpráva o detekci chrápání",
            "snoreRecord": "Záznam chrápání",
            "more": "Zobrazit více",
            "notOpenedTip": "Před spaním zapněte prosím funkci monitorování chrápání v kartě \"Domů-Spánek-Zahájit spánek-Spiejte nyní\". Nezapomeňte po spánku monitorování vypnout, a bude automaticky vytvořen záznam chrápání.",
            "noSnoring": "Žádné chrápání během tohoto spánku~",
            "snoreData": "Údaje o hluku chrápání",
            "snoreReport": "Zpráva o chrápání",
            "snoreDuration": "Trvání",
            "avgSnoreDb": "Průměrný hladina decibelů",
            "maxSnoreDb": "Maximální hladina decibelů",
            "minSnoreDb": "Minimální hladina decibelů",
            "snoreDbRatio": "Poměr decibelů chrápání",
            "snoreWaveforms": "Trend vlnění chrápání",
            "snoreFrequency": "Frekvence distribuce chrápání",
            "snoreFrequencyTrend": "Trend frekvence chrapotu",
            "low": "Nízká frekvence",
            "medium": "Střední frekvence",
            "high": "Vysoká frekvence",
            "softSnore": "Měkké patro chrápání",
            "uvulaSnore": "Chrápání mandle",
            "tongueSnore": "Chrápání kořene jazyka",
            "snoreRecordSetting": "Nastavení",
            "storageMethods": "Způsob ukládání",
            "storageDurations": "Čas ukládání",
            "local": "Místní",
            "cloud": "Cloud",
            "localStorage": "Lokální úložiště",
            "cloudStorage": "Cloudové uložení",
            "storageWayTips": "Můžete si vybrat, zda chcete ukládat svá data o chrápání lokálně nebo do cloudu. Ukládání lokálně zabere váš prostor na disku. Ukládání do cloudu vyžaduje členství v sleep membership, kde jsou vaše data uchovávána po dobu maximálně 180 dní.",
            "storagePeriod": "Můžete si vybrat dobu uchovávání dat o chrápání. Pro zajištění bezpečnosti vašich dat jsme nastavili minimální dobu uchovávání 1 den a maximálně 180 dní. Pokud zvolíte 1 den, vaše data o chrápání budou smazána následující den. Členové mohou využívat doby uchovávání 30 a 180 dní po předplatném.",
            "storagePeriodWearCopilot": "Můžete si vybrat dobu uchovávání dat o chrápání.",
            "day": "Den",
            "days": "Dní",
            recordSnoreTitle1: '1.Zaznamenávat chrápání',
            recordSnoreContent1: 'Před spaním zapněte funkci detekce chrápání a nezapomeňte ručně ukončit spánek, abyste zaznamenali úplná data o chrápání.',
            recordSnoreTitle2: '2.Zkontrolujte záznam chrápání v denní zprávě',
            recordSnoreContent2: 'V denní zprávě lze zobrazit 3 záznamy chrápání. Klepnutím na ně si můžete přehrávat své vlastní záznamy chrápání.',
            recordSnoreTitle3: '3.Další analýza dat o chrápání',
            recordSnoreContent3: 'V každodenním zprávě klikněte na "Více", abyste viděli všechny záznamy chrápání a analyzovali úroveň hlasitosti, vlny, distribuci, frekvenci atd.',
            "tips": "Tip",
            "vipTips": "Chcete-li tuto funkci aktivovat, musíte se přihlásit k členství ve spánku. Chcete se nyní přihlásit k členství ve spánku?",
            "open": "Aktivovat nyní",
            "noAudioTip": "Zvuk chrápání se načítá, prosím, počkejte.",
        },
    },
}

export default cs
